/** Playback en el cliente: arma el embed desde media_url/título. El backend solo valida al guardar. */
function hostnameOf(url) {
  try {
    let host = new URL(url).hostname.replace(/^www\./i, '').toLowerCase();
    if (host.startsWith('m.')) host = host.slice(2);
    if (host.startsWith('music.')) host = host.slice(6);
    return host;
  } catch {
    return '';
  }
}

function youtubeVideoId(parsed) {
  const host = hostnameOf(parsed.toString());
  const parts = parsed.pathname.split('/').filter(Boolean);
  if (host === 'youtu.be') return (parts[0] || '').split('?')[0];
  if (host === 'youtube.com' || host === 'youtube-nocookie.com') {
    if (parsed.searchParams.get('v')) return parsed.searchParams.get('v');
    const kind = parts[0];
    if (['embed', 'shorts', 'live', 'v', 'watch'].includes(kind) && parts[1]) return parts[1];
    return parts[parts.length - 1] || '';
  }
  return '';
}

export function looksLikeVideoUrl(value) {
  const s = String(value || '').trim();
  return /^https?:\/\//i.test(s);
}

export function toSpiritualEmbedClient(raw) {
  const input = String(raw || '').trim();
  if (!input) return { type: 'none', src: '' };
  let parsed;
  try {
    parsed = new URL(input);
  } catch {
    return { type: 'none', src: '' };
  }
  if (parsed.protocol !== 'https:') return { type: 'none', src: '' };
  const host = hostnameOf(input);
  if (host === 'youtu.be' || host === 'youtube.com' || host === 'youtube-nocookie.com') {
    const id = youtubeVideoId(parsed);
    if (!id || !/^[a-zA-Z0-9_-]{6,}$/.test(id)) return { type: 'none', src: '' };
    return { type: 'iframe', src: `https://www.youtube.com/embed/${id}?playsinline=1&rel=0` };
  }
  if (host === 'vimeo.com' || host === 'player.vimeo.com') {
    const id = parsed.pathname.split('/').filter(Boolean).pop();
    return { type: 'iframe', src: id ? `https://player.vimeo.com/video/${id}` : '' };
  }
  if (/\.mp4$/i.test(parsed.pathname)) return { type: 'video', src: parsed.toString() };
  return { type: 'none', src: '' };
}

export function resolveSpiritualPlayer(media) {
  if (!media) return { type: 'none', src: '' };
  const fromUrl = toSpiritualEmbedClient(media.media_url);
  if (fromUrl.src) return fromUrl;
  if (looksLikeVideoUrl(media.title)) return toSpiritualEmbedClient(media.title);
  if (media.embed_src) {
    return { type: media.embed_type === 'video' ? 'video' : 'iframe', src: media.embed_src };
  }
  return { type: 'none', src: '' };
}
